import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stlyeguide',
  templateUrl: './stlyeguide.component.html',
  styleUrls: ['./stlyeguide.component.scss']
})
export class StlyeguideComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
